
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function StrengthTrainingGuidance() {
  const [selectedLevel, setSelectedLevel] = useState('beginner');
  const [selectedCategory, setSelectedCategory] = useState('all');

  const trainingPrograms = {
    beginner: [
      {
        name: '椅子を使った立ち上がり運動',
        category: 'lower',
        duration: '10-15分',
        frequency: '週3回',
        description: '椅子から立ち上がる動作を繰り返し、太ももの筋肉を強化します。',
        steps: [
          '椅子に浅く座り、足を肩幅に開く',
          '腕を胸の前で組む',
          'ゆっくりと立ち上がる（3秒かけて）',
          'ゆっくりと座る（3秒かけて）',
          '10回×3セット実施'
        ],
        image: 'https://public.readdy.ai/ai/img_res/eacea9e976aa7c4dc8e68f95d92826ce.jpg'
      },
      {
        name: 'ウォールプッシュアップ',
        category: 'upper',
        duration: '5-10分',
        frequency: '週3回',
        description: '壁を使った腕立て伏せで、上半身の筋力を安全に鍛えます。',
        steps: [
          '壁から腕の長さ分離れて立つ',
          '肩幅に手を開いて壁に手をつく',
          'ゆっくりと壁に向かって体を倒す',
          'ゆっくりと元の位置に戻る',
          '10回×2セット実施'
        ],
        image: 'https://readdy.ai/api/search-image?query=Senior%20person%20doing%20wall%20push-ups%20exercise%2C%20safe%20upper%20body%20strength%20training%20at%20home%2C%20proper%20form%20demonstration%2C%20elderly%20fitness%20program%2C%20beginner%20level%20exercise&width=400&height=300&seq=wall-pushup-exercise&orientation=landscape'
      },
      {
        name: 'かかと上げ運動',
        category: 'lower',
        duration: '5-10分',
        frequency: '毎日',
        description: 'ふくらはぎの筋肉を鍛え、歩行能力の向上を図ります。',
        steps: [
          '椅子の背もたれに軽く手を添える',
          '足を肩幅に開いて立つ',
          'かかとをゆっくりと上げる（2秒）',
          'ゆっくりと下ろす（2秒）',
          '15回×3セット実施'
        ],
        image: 'https://readdy.ai/api/search-image?query=Elderly%20person%20doing%20calf%20raise%20exercise%20with%20chair%20support%2C%20heel%20lift%20exercise%20for%20seniors%2C%20safe%20lower%20body%20strengthening%2C%20home%20fitness%20for%20elderly%2C%20proper%20exercise%20form&width=400&height=300&seq=calf-raise-exercise&orientation=landscape'
      }
    ],
    intermediate: [
      {
        name: 'スクワット（浅め）',
        category: 'lower',
        duration: '10-15分',
        frequency: '週3回',
        description: '膝を軽く曲げるスクワットで、下半身全体を強化します。',
        steps: [
          '足を肩幅に開いて立つ',
          '腕を前に伸ばしてバランスを取る',
          '膝を45度程度曲げてしゃがむ',
          'ゆっくりと立ち上がる',
          '12回×3セット実施'
        ],
        image: 'https://readdy.ai/api/search-image?query=Middle-aged%20person%20doing%20shallow%20squat%20exercise%2C%20intermediate%20level%20strength%20training%2C%20proper%20squat%20form%20demonstration%2C%20home%20fitness%20routine%2C%20lower%20body%20strengthening%20exercise&width=400&height=300&seq=shallow-squat-exercise&orientation=landscape'
      },
      {
        name: '膝つき腕立て伏せ',
        category: 'upper',
        duration: '10-15分',
        frequency: '週3回',
        description: '膝をついた状態での腕立て伏せで、上半身の筋力を段階的に向上させます。',
        steps: [
          '膝をついて四つん這いになる',
          '手は肩幅より少し広めに置く',
          '体を一直線に保ちながら腕立て伏せ',
          'ゆっくりと上下運動を行う',
          '8回×3セット実施'
        ],
        image: 'https://readdy.ai/api/search-image?query=Person%20doing%20modified%20push-ups%20on%20knees%2C%20intermediate%20upper%20body%20exercise%2C%20proper%20form%20demonstration%2C%20home%20strength%20training%2C%20progressive%20fitness%20routine&width=400&height=300&seq=knee-pushup-exercise&orientation=landscape'
      },
      {
        name: 'サイドステップ',
        category: 'balance',
        duration: '10-15分',
        frequency: '週3回',
        description: '横方向の動きでバランス感覚と下半身の筋力を同時に鍛えます。',
        steps: [
          '足を揃えて立つ',
          '右足を横に大きく一歩踏み出す',
          '左足を右足に寄せる',
          '左右交互に10歩ずつ移動',
          '3セット実施'
        ],
        image: 'https://readdy.ai/api/search-image?query=Person%20doing%20side%20step%20exercise%20for%20balance%20and%20strength%2C%20lateral%20movement%20training%2C%20intermediate%20fitness%20routine%2C%20home%20exercise%20for%20coordination%20and%20muscle%20strength&width=400&height=300&seq=side-step-exercise&orientation=landscape'
      }
    ],
    advanced: [
      {
        name: 'フルスクワット',
        category: 'lower',
        duration: '15-20分',
        frequency: '週3回',
        description: '完全なスクワットで下半身の筋力を最大限に鍛えます。',
        steps: [
          '足を肩幅に開いて立つ',
          '腕を前に伸ばしてバランスを取る',
          '太ももが床と平行になるまでしゃがむ',
          '力強く立ち上がる',
          '15回×3セット実施'
        ],
        image: 'https://readdy.ai/api/search-image?query=Athletic%20person%20doing%20full%20deep%20squat%20exercise%2C%20advanced%20strength%20training%2C%20perfect%20squat%20form%20demonstration%2C%20intense%20lower%20body%20workout%2C%20professional%20fitness%20routine&width=400&height=300&seq=full-squat-exercise&orientation=landscape'
      },
      {
        name: '標準腕立て伏せ',
        category: 'upper',
        duration: '15-20分',
        frequency: '週3回',
        description: '標準的な腕立て伏せで上半身の筋力を総合的に強化します。',
        steps: [
          'うつ伏せになり、手を肩幅に置く',
          'つま先と手で体を支える',
          '体を一直線に保ちながら上下運動',
          '胸が床につく直前まで下げる',
          '12回×3セット実施'
        ],
        image: 'https://readdy.ai/api/search-image?query=Fit%20person%20doing%20standard%20push-ups%20exercise%2C%20advanced%20upper%20body%20strength%20training%2C%20perfect%20push-up%20form%2C%20intense%20home%20workout%2C%20professional%20fitness%20demonstration&width=400&height=300&seq=standard-pushup-exercise&orientation=landscape'
      },
      {
        name: 'シングルレッグスタンド',
        category: 'balance',
        duration: '10-15分',
        frequency: '毎日',
        description: '片足立ちでバランス感覚と体幹の安定性を高めます。',
        steps: [
          '片足で立ち、もう一方の足を軽く上げる',
          '30秒間バランスを保つ',
          '左右交互に実施',
          '慣れてきたら目を閉じて挑戦',
          '各足3回ずつ実施'
        ],
        image: 'https://readdy.ai/api/search-image?query=Person%20doing%20single%20leg%20stand%20balance%20exercise%2C%20advanced%20balance%20training%2C%20core%20stability%20workout%2C%20challenging%20fitness%20routine%2C%20professional%20balance%20demonstration&width=400&height=300&seq=single-leg-stand&orientation=landscape'
      }
    ]
  };

  const getCurrentPrograms = () => {
    const programs = trainingPrograms[selectedLevel as keyof typeof trainingPrograms];
    if (selectedCategory === 'all') return programs;
    return programs.filter(program => program.category === selectedCategory);
  };

  const safetyTips = [
    {
      icon: 'ri-heart-pulse-line',
      title: '体調チェック',
      description: '運動前に体調を確認し、痛みや不調がある場合は無理をしない'
    },
    {
      icon: 'ri-time-line',
      title: 'ウォームアップ',
      description: '運動前に5-10分の軽いストレッチや準備運動を行う'
    },
    {
      icon: 'ri-drop-line',
      title: '水分補給',
      description: '運動中は適度な水分補給を心がける'
    },
    {
      icon: 'ri-speed-line',
      title: '適切なペース',
      description: 'ゆっくりとした動作で正しいフォームを意識する'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="flex items-center">
                <div className="w-10 h-10 mr-3 relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-lg transform rotate-12 shadow-lg"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-lg flex items-center justify-center">
                    <i className="ri-heart-pulse-fill text-white text-lg"></i>
                  </div>
                </div>
                <div className="text-xl font-bold text-teal-600" style={{ fontFamily: '"Pacifico", serif' }}>
                  みんなの薬局～Pharmacare～
                </div>
              </Link>
            </div>
            <nav className="hidden md:flex space-x-8">
              <Link to="/health-support" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">健康サポート</Link>
              <Link to="/sarcopenia/muscle-strength-assessment" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">筋力測定・評価</Link>
              <Link to="/sarcopenia/protein-intake-guidance" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">タンパク質指導</Link>
              <Link to="/sarcopenia/progress-monitoring" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">進捗モニタリング</Link>
            </nav>
          </div>
        </div>
      </header>

      {/* Breadcrumb */}
      <div className="bg-gray-50 py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center space-x-2 text-sm text-gray-600">
            <Link to="/" className="hover:text-teal-600 cursor-pointer">ホーム</Link>
            <i className="ri-arrow-right-s-line"></i>
            <Link to="/health-support" className="hover:text-teal-600 cursor-pointer">健康サポート</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-gray-900">筋力トレーニング指導</span>
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-orange-50 to-red-50 py-16">
        <div className="absolute inset-0">
          <img 
            src="https://readdy.ai/api/search-image?query=Professional%20fitness%20instructor%20demonstrating%20strength%20training%20exercises%20for%20elderly%20people%20in%20modern%20gym%20setting%2C%20safe%20exercise%20equipment%2C%20group%20fitness%20class%20for%20seniors%2C%20healthcare-focused%20strength%20training%20program&width=1200&height=400&seq=strength-training-hero&orientation=landscape"
            alt="筋力トレーニング指導"
            className="w-full h-full object-cover object-top opacity-20"
          />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              筋力トレーニング指導
            </h1>
            <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
              個人の体力レベルに合わせた安全で効果的なトレーニングプログラムをご提供します。サルコペニア予防・改善のための段階的なアプローチで、無理なく筋力向上を目指しましょう。
            </p>
          </div>
        </div>
      </section>

      {/* Level Selection */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">あなたのレベルを選択</h2>
            <p className="text-lg text-gray-600">現在の体力レベルに合わせたトレーニングプログラムを選択してください</p>
          </div>

          <div className="flex justify-center mb-8">
            <div className="flex bg-gray-100 rounded-full p-1">
              <button
                onClick={() => setSelectedLevel('beginner')}
                className={`px-6 py-2 rounded-full font-medium transition-all whitespace-nowrap cursor-pointer ${
                  selectedLevel === 'beginner' 
                    ? 'bg-orange-600 text-white' 
                    : 'text-gray-600 hover:text-orange-600'
                }`}
              >
                初級者
              </button>
              <button
                onClick={() => setSelectedLevel('intermediate')}
                className={`px-6 py-2 rounded-full font-medium transition-all whitespace-nowrap cursor-pointer ${
                  selectedLevel === 'intermediate' 
                    ? 'bg-orange-600 text-white' 
                    : 'text-gray-600 hover:text-orange-600'
                }`}
              >
                中級者
              </button>
              <button
                onClick={() => setSelectedLevel('advanced')}
                className={`px-6 py-2 rounded-full font-medium transition-all whitespace-nowrap cursor-pointer ${
                  selectedLevel === 'advanced' 
                    ? 'bg-orange-600 text-white' 
                    : 'text-gray-600 hover:text-orange-600'
                }`}
              >
                上級者
              </button>
            </div>
          </div>

          <div className="flex justify-center mb-8">
            <div className="flex bg-gray-100 rounded-full p-1">
              <button
                onClick={() => setSelectedCategory('all')}
                className={`px-4 py-2 rounded-full font-medium transition-all whitespace-nowrap cursor-pointer ${
                  selectedCategory === 'all' 
                    ? 'bg-teal-600 text-white' 
                    : 'text-gray-600 hover:text-teal-600'
                }`}
              >
                すべて
              </button>
              <button
                onClick={() => setSelectedCategory('upper')}
                className={`px-4 py-2 rounded-full font-medium transition-all whitespace-nowrap cursor-pointer ${
                  selectedCategory === 'upper' 
                    ? 'bg-teal-600 text-white' 
                    : 'text-gray-600 hover:text-teal-600'
                }`}
              >
                上半身
              </button>
              <button
                onClick={() => setSelectedCategory('lower')}
                className={`px-4 py-2 rounded-full font-medium transition-all whitespace-nowrap cursor-pointer ${
                  selectedCategory === 'lower' 
                    ? 'bg-teal-600 text-white' 
                    : 'text-gray-600 hover:text-teal-600'
                }`}
              >
                下半身
              </button>
              <button
                onClick={() => setSelectedCategory('balance')}
                className={`px-4 py-2 rounded-full font-medium transition-all whitespace-nowrap cursor-pointer ${
                  selectedCategory === 'balance' 
                    ? 'bg-teal-600 text-white' 
                    : 'text-gray-600 hover:text-teal-600'
                }`}
              >
                バランス
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Training Programs */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {getCurrentPrograms().map((program, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden">
                <img 
                  src={program.image}
                  alt={program.name}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="p-6">
                  <div className="flex items-center justify-between mb-3">
                    <h3 className="text-xl font-semibold text-gray-900">{program.name}</h3>
                    <div className="flex space-x-2">
                      <span className="bg-orange-100 text-orange-800 text-xs px-2 py-1 rounded-full">
                        {program.duration}
                      </span>
                      <span className="bg-teal-100 text-teal-800 text-xs px-2 py-1 rounded-full">
                        {program.frequency}
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-600 mb-4">{program.description}</p>
                  
                  <div className="space-y-2">
                    <h4 className="font-semibold text-gray-900">実施手順:</h4>
                    <ol className="text-sm text-gray-600 space-y-1">
                      {program.steps.map((step, stepIndex) => (
                        <li key={stepIndex} className="flex items-start">
                          <span className="bg-orange-100 text-orange-800 text-xs px-2 py-1 rounded-full mr-2 mt-0.5 flex-shrink-0">
                            {stepIndex + 1}
                          </span>
                          <span>{step}</span>
                        </li>
                      ))}
                    </ol>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Safety Tips */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">安全にトレーニングを行うために</h2>
            <p className="text-lg text-gray-600">怪我を防ぎ、効果的にトレーニングを行うための重要なポイント</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {safetyTips.map((tip, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg p-6 border border-gray-100 text-center">
                <div className="w-16 h-16 bg-red-50 text-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${tip.icon} text-2xl`}></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">{tip.title}</h3>
                <p className="text-gray-600">{tip.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Weekly Schedule */}
      <section className="py-16 bg-gradient-to-br from-teal-50 to-blue-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">推奨週間スケジュール</h2>
            <p className="text-lg text-gray-600">効果的な筋力向上のための理想的なトレーニングスケジュール</p>
          </div>

          <div className="bg-white rounded-2xl shadow-xl p-8">
            <div className="grid md:grid-cols-7 gap-4">
              {['月', '火', '水', '木', '金', '土', '日'].map((day, index) => (
                <div key={index} className="text-center">
                  <div className="bg-teal-600 text-white rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-3 font-bold">
                    {day}
                  </div>
                  <div className="space-y-2 text-sm">
                    {index % 2 === 0 ? (
                      <>
                        <div className="bg-orange-100 text-orange-800 px-2 py-1 rounded text-xs">筋トレ</div>
                        <div className="text-gray-600">30分</div>
                      </>
                    ) : index === 6 ? (
                      <>
                        <div className="bg-green-100 text-green-800 px-2 py-1 rounded text-xs">休息</div>
                        <div className="text-gray-600">完全休養</div>
                      </>
                    ) : (
                      <>
                        <div className="bg-blue-100 text-blue-800 px-2 py-1 rounded text-xs">軽運動</div>
                        <div className="text-gray-600">散歩など</div>
                      </>
                    )}
                  </div>
                </div>
              ))}
            </div>
            
            <div className="mt-8 p-4 bg-yellow-50 rounded-lg border border-yellow-200">
              <div className="flex items-start">
                <i className="ri-lightbulb-line text-yellow-600 text-xl mr-3 mt-1"></i>
                <div>
                  <h4 className="font-semibold text-yellow-800 mb-2">スケジュールのポイント</h4>
                  <ul className="text-sm text-yellow-700 space-y-1">
                    <li>• 筋トレは週3回、1日おきに実施</li>
                    <li>• 休息日は軽い有酸素運動（散歩など）を推奨</li>
                    <li>• 完全休養日を週1回設ける</li>
                    <li>• 体調に合わせて調整することが重要</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Progress Tracking */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">進捗管理のすすめ</h2>
            <p className="text-lg text-gray-600">トレーニング効果を最大化するための記録と評価方法</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <Link to="/sarcopenia/progress-monitoring" className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow p-8 border border-gray-100 cursor-pointer">
              <div className="w-16 h-16 bg-blue-50 text-blue-600 rounded-lg flex items-center justify-center mx-auto mb-6">
                <i className="ri-line-chart-line text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4 text-center">進捗モニタリング</h3>
              <p className="text-gray-600 text-center mb-4">定期的な測定と記録で改善状況を可視化</p>
              <div className="text-center">
                <span className="text-blue-600 font-medium">詳細を見る →</span>
              </div>
            </Link>

            <Link to="/sarcopenia/protein-intake-guidance" className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow p-8 border border-gray-100 cursor-pointer">
              <div className="w-16 h-16 bg-green-50 text-green-600 rounded-lg flex items-center justify-center mx-auto mb-6">
                <i className="ri-restaurant-line text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4 text-center">栄養サポート</h3>
              <p className="text-gray-600 text-center mb-4">筋肉合成に必要な栄養素の摂取指導</p>
              <div className="text-center">
                <span className="text-green-600 font-medium">詳細を見る →</span>
              </div>
            </Link>

            <Link to="/sarcopenia/muscle-strength-assessment" className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow p-8 border border-gray-100 cursor-pointer">
              <div className="w-16 h-16 bg-purple-50 text-purple-600 rounded-lg flex items-center justify-center mx-auto mb-6">
                <i className="ri-pulse-line text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4 text-center">定期評価</h3>
              <p className="text-gray-600 text-center mb-4">月1回の筋力測定で効果を確認</p>
              <div className="text-center">
                <span className="text-purple-600 font-medium">詳細を見る →</span>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center mb-4">
                <div className="w-8 h-8 mr-2 relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-lg transform rotate-12"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-300 to-emerald-300 rounded-lg flex items-center justify-center">
                    <i className="ri-heart-pulse-fill text-white text-sm"></i>
                  </div>
                </div>
                <div className="text-xl font-bold text-teal-400" style={{ fontFamily: '"Pacifico", serif' }}>
                  みんなの薬局～Pharmacare～
                </div>
              </div>
              <p className="text-gray-400">
                患者さんと薬剤師をつなぐ総合医療情報プラットフォーム
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">サルコペニア予防</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/sarcopenia/muscle-strength-assessment" className="hover:text-white cursor-pointer">筋力測定・評価</Link></li>
                <li><Link to="/sarcopenia/strength-training-guidance" className="hover:text-white cursor-pointer">筋力トレーニング指導</Link></li>
                <li><Link to="/sarcopenia/protein-intake-guidance" className="hover:text-white cursor-pointer">タンパク質摂取指導</Link></li>
                <li><Link to="/sarcopenia/progress-monitoring" className="hover:text-white cursor-pointer">進捗モニタリング</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">健康サポート</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/health-support" className="hover:text-white cursor-pointer">セルフケア支援</Link></li>
                <li><Link to="/otc" className="hover:text-white cursor-pointer">OTC医薬品</Link></li>
                <li><Link to="/kampo" className="hover:text-white cursor-pointer">漢方相談</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">情報・リンク</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/information" className="hover:text-white cursor-pointer">公的機関リンク</Link></li>
                <li><Link to="/beast-blog" className="hover:text-white cursor-pointer">ビースト君ブログ</Link></li>
                <li><Link to="/career" className="hover:text-white cursor-pointer">転職・派遣情報</Link></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 みんなの薬局～Pharmacare～. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-white cursor-pointer">Website Builder</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}
